export class UpdateLanguageFailure {
    static readonly type = '[User] UpdateLanguageFailure';
}
